import React from 'react'
import {
    createRegisterableComponent,
    ElectionDefinition,
    isElectionFeatureEnabled,
} from '@news-mono/web-common'
import { PartyTotalsComponent } from './PartyTotals'

type PartyTotalsRouteProps = {
    electionDefinition: ElectionDefinition
    /** This description appears below the "Party Totals" heading and in the sharing component */
    description: string
    colorMode?: 'light' | 'dark'
}
export const PartyTotalsRegistration = createRegisterableComponent(
    'election-party-totals',
    (props: PartyTotalsRouteProps, { onEvent, store }) => {
        const isTppWidgetEnabled = isElectionFeatureEnabled(
            store.getState().toggles,
            props.electionDefinition.electionId,
            'election-party-totals-tpp-estimate-widget',
        )

        return (
            <PartyTotalsComponent
                onEvent={onEvent}
                isTppWidgetEnabled={isTppWidgetEnabled}
                {...props}
            />
        )
    },
)
